import { logErrorToFirestore } from '../firebase';

const originalConsoleLog = console.log;
const originalConsoleWarn = console.warn;
const originalConsoleError = console.error;

const ignorePatterns = [
  /@firebase\/firestore/,
  /WebChannelConnection/,
  /PersistentStream/,
  /A component is `contentEditable` and contains `children` managed by React/,
];

const shouldIgnore = (message: string) => {
  return ignorePatterns.some((pattern) => pattern.test(message));
};

console.log = (...args) => {
  if (!shouldIgnore(args[0])) {
    originalConsoleLog(...args);
  }
};

console.warn = (...args) => {
  if (!shouldIgnore(args[0])) {
    originalConsoleWarn(...args);
  }
};

console.error = async (...args) => {
  if (!shouldIgnore(args[0])) {
    originalConsoleError(...args);


    const errorMessagesToIgnore = [
      "Warning: You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.",
      "Error while reading CSS rules from https://fonts.googleapis.com",
      "Error loading remote stylesheet",
      "Error inlining remote css file"
    ];

    if (errorMessagesToIgnore.some((msg) => args[0].includes(msg))) {
      return;
    }

    await logErrorToFirestore(args[0]); // Log the error to Firestore
  }
};

// Add this line to make the file a module
export {};